import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';

const questionConfig = getQuestionConfig(ProfilerQuestionID.SPOUSE_BUSINESS_INVOLVEMENT);

const SpouseHelps = ({
  questionId = ProfilerQuestionID.SPOUSE_BUSINESS_INVOLVEMENT,
  title = questionConfig?.question,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  options = questionConfig?.options || [],
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;
  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
  };
  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };
  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        <CardHeader title={title} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {options.map((option) => {
            const isSelected = selectedValue === option.value;
              return (
                <Box
                  key={option.value}
                  onClick={() => handleSelect(option.value)}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: isSelected ? '2px solid #995A00' : '1px solid #995A00',
                    borderRadius: 2,
                    p: 2,
                    minHeight: 64,
                    cursor: 'pointer',
                    background: isSelected ? '#995A001F' : '#fff',
                    transition: 'border 0.2s, background 0.2s',
                  }}
                >
                  {option?.icon && (
                    <Box component={'img'} src={option.icon} alt={option.label} width={33} height={33} sx={{ mr: 2, objectFit: 'contain' }} />
                  )}
                  <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Typography variant='labelD' >{option.label}</Typography>
                  </Box>
                </Box>
              );
          })}
        </Box>
        <CustomButton
          size='small'
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          sx={{ width: '100%', mt: 'auto', pt: 1 }}
        />
      </Box>
    </Box>
  );
};

export default SpouseHelps;
